export default __webpack_public_path__ + "static/avatar-2-e10ba73cc1ee278dfef7ff3bb4ba5f50.png";